import React, { useState, useEffect } from 'react';

const Events = () => {
  const [pages, setPages] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetch('https://ocdnewyork.org/wp/wp-json/wp/v2/posts?tags=7');
      const data = await response.json();
      setPages(data);
    }

    fetchData();
  }, []);
  const toggleButtons = document.querySelectorAll('.close');
  const hiddenContent = document.querySelector('.overlay');

  toggleButtons.forEach(button => {
    button.addEventListener('click', () => {
      hiddenContent.classList.remove('show');
    });
  });
  return (
    <div className='events'>
      {pages.map((page) => {
        return (
        <div className='event'>
          <h2>{page.title.rendered}</h2>
          <div dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div>
        </div>
      )
      })}
    </div>    
  );
}

export default Events;